import React from "react";
import {useDispatch} from "react-redux";

import {addElement} from "../../store/product/productElementsSlice";

const ElementDropdownItem = (props) => {

    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(addElement(props.element));
        props.onClick()
    }

    const style={
        dropdown: {
            backgroundColor: 'black',
            color: 'white',
            maxWidth: '200px',
            padding: '7px 10px',
            // borderRadius: '5px',
            borderBottom: '1px solid white',
            zIndex: '9999'
        }
    }
    return(<div style={style.dropdown} onClick={handleClick}>{props.text}</div>);
}

export default ElementDropdownItem;